<app-card-widget title="Emails (old)" *ngIf="data$ | async as data">

  <form [formGroup]="form" id="email-form" (ngSubmit)="save()" novalidate>

    <div class="card-section-container">

      <div class="card-section" *ngIf="!added">
        <mat-nav-list>
          <mat-list-item *ngFor="let item of data.emailLogs" (click)="itemClicked(item)" [class.mat-elevation-z2]="item === selectedItem">
            <mat-icon matListIcon>email</mat-icon>
            <h3 matLine>{{item.subject}}</h3>
            <span matLine>{{item.recipient}}</span>
            <div class="list-item-container">
              <app-email-state-label [emailStateId]="item.emailStateId"></app-email-state-label>
              <div class="list-item-timestamp">{{item.created | date:'short'}}</div>
            </div>
          </mat-list-item>
        </mat-nav-list>
      </div>

      <div class="card-section" *ngIf="selectedItem && !added">
        <app-text label="State">{{data.emailStates.get(selectedItem.emailStateId)?.name}}</app-text>
        <app-text label="Recipient">{{selectedItem.recipient}}</app-text>
        <app-text label="Subject">{{selectedItem.subject}}</app-text>
        <app-text label="Message"><pre style="white-space: pre-wrap">{{selectedItem.message}}</pre></app-text>
        <app-text label="User">{{data.users.get(selectedItem.userId)?.name}}</app-text>
        <app-text label="Created">{{selectedItem.created | date:'medium'}}</app-text>
      </div>

      <div class="card-section" *ngIf="added">
        <mat-form-field *ngIf="added">
          <mat-select placeholder="Template" formControlName="emailTemplateId" (selectionChange)="templateChange($event)">
            <mat-option *ngFor="let template of data.emailTemplates" [value]="template">
              {{template.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="added">
          <input matInput placeholder="Recipient" formControlName="recipient"/>
        </mat-form-field>

        <mat-form-field *ngIf="added">
          <input matInput placeholder="Subject" formControlName="subject"/>
        </mat-form-field>

        <mat-form-field *ngIf="added">
          <textarea matInput placeholder="Message" formControlName="message" rows="18"></textarea>
        </mat-form-field>
      </div>

      <div class="card-section" *ngIf="added">
        <mat-selection-list formControlName="invoiceAttachmentIds" *ngIf="added" placeholder="Attachments">
          <mat-list-option *ngFor="let invoiceAttachment of data.invoiceAttachments" [value]="invoiceAttachment.invoiceAttachmentId">
            <h3 matLine>{{invoiceAttachment.originalFileName}}</h3>
            <span matLine>{{data.invoiceAttachmentTypes.get(invoiceAttachment.invoiceAttachmentTypeId)?.description}}</span>
          </mat-list-option>
        </mat-selection-list>
      </div>

    </div>

  </form>

  <mat-card-actions align="end">
    <button type="button" mat-button *ngIf="!added && !added" [disabled]="locked" (click)="add()">Add</button>
    <button type="submit" mat-button *ngIf="added" [disabled]="!form.valid || saving" form="email-form">Send</button>
    <button type="reset" mat-button *ngIf="added" (click)="revert()">Cancel</button>
  </mat-card-actions>

</app-card-widget>


